import React, { Suspense, useEffect, useState } from 'react'
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownButton,
  Table
} from 'react-bootstrap'
import Accordion from 'react-bootstrap/Accordion'
import ReactPaginate from 'react-paginate'
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useSearchParams } from 'react-router-dom'
import Select from 'react-select'
import Swal from 'sweetalert2'
import { useImmer } from 'use-immer'
import AddInExistingIcon from '../../components/AllSvgIcon/AddInExistingIcon'
import ArchieveIcon from '../../components/AllSvgIcon/ArchieveIcon'
import EditIcon from '../../components/AllSvgIcon/EditIcon'
import InfoRoundedIcon from '../../components/AllSvgIcon/InfoRoundedIcon'
import Previewicon from '../../components/AllSvgIcon/Previewicon'
import QuickEditIcon from '../../components/AllSvgIcon/QuickEditIcon'
import HKBadge from '../../components/Badges'
import Loader from '../../components/Loader'
import SearchBox from '../../components/Searchbox'
import CustomToast from '../../components/Toast/CustomToast'
import { customStyles } from '../../components/customStyles'
import {
  calculatePageRange,
  callApi,
  decodeId,
  encodeId,
  encodedSearchText,
  fetchCalculation,
  prepareDisplayCalculationData,
  showToast,
  spaceToDash
} from '../../lib/AllGlobalFunction'
import { allCrudNames, allPages, checkPageAccess } from '../../lib/AllPageNames'
import {
  currencyIcon,
  isInventoryModel,
  isSellerPanel,
  pageRangeDisplayed,
  productStatus
} from '../../lib/AllStaticVariables'
import axiosProvider from '../../lib/AxiosProvider'
import { getFrontendUrl } from '../../lib/GetBaseUrl'
import { _productImg_ } from '../../lib/ImagePath'
import { _SwalDelete, _exception } from '../../lib/exceptionMessage'
import useDebounce from '../../lib/useDebounce'
import NotFound from '../../pages/NotFound/NotFound'
import { setPageTitle } from '../redux/slice/pageTitleSlice'

const BulkUpload = React.lazy(() => import('./BulkUpload'))
const BulkStockUpdate = React.lazy(() => import('./BulkStockUpdate'))
const ProductDetail = React.lazy(() => import('./ProductDetail'))
const QuickUpdate = React.lazy(() => import('./QuickUpdate'))
const TotalSellerSellingProduct = React.lazy(() =>
  import('./TotalSellers/TotalSellerSellingProduct')
)

const ManageProduct = () => {
  const [expandedRow, setExpandedRow] = useState()
  const [loading, setLoading] = useState(false)
  const [allState, setAllState] = useState()
  const [data, setData] = useState()
  const [toast, setToast] = useState({
    show: false,
    text: null,
    variation: null
  })
  const [previewOffCanvasShow, setPreviewOffCanvasShow] = useState(false)
  const [searchParams] = useSearchParams()
  const encodedId = searchParams.get('id')
  const id = encodedId ? decodeId(encodedId) : null
  const sellerProductId = searchParams.get('sellerProductId')
  const { pageAccess, userInfo, sellerDetails } = useSelector(
    (state) => state.user
  )
  const [quickUpdate, setQuickUpdate] = useState({
    id: null,
    show: false,
    isDataUpdated: false
  })
  const [searchText, setSearchText] = useState('')
  const debounceSearchText = useDebounce(searchText, 500)
  const [filterDetails, setFilterDetails] = useImmer({
    sellerId: isInventoryModel
      ? sellerDetails?.id
        ? sellerDetails?.id
        : userInfo?.userId
      : '',
    brandId: '',
    categoryId: '',
    live: '',
    pageIndex: 1,
    pageSize: 50,
    status: '',
    searchText: ''
  })
  const [modalShow, setModalShow] = useState({ show: false, type: '' })
  const location = useLocation()

  useEffect(() => {
    dispatch(setPageTitle('Product'))
  }, [])

  const dispatch = useDispatch()

  const handlePageClick = (event) => {
    setFilterDetails((draft) => {
      draft.pageIndex = event.selected + 1
    })
  }

  const handleArchive = async (data) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'PUT',
        endpoint: 'Product/ArchiveProduct',
        queryString: `?productId=${data?.productId}&sellerProductId=${data?.sellerProductId}`,
        location: location?.pathname,
        userId: userInfo?.userId,
        oldData: {}
      })
      setLoading(false)

      if (response?.data?.code === 200) {
        fetchPageData()
      }
      showToast(toast, setToast, response)
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const fetchAllGenericData = async (apiUrls) => {
    try {
      const responseArray = await Promise.all(
        apiUrls.map((url) => callApi(url.endpoint, url.queryString, url.state))
      )

      return responseArray.filter((response) => response !== undefined)
    } catch (error) {}
  }

  const fetchData = async (endpoint, setterFunc) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint
      })
      setLoading(false)
      if (response?.status === 200) {
        return setterFunc(response)
      }
    } catch {
      setLoading(false)
    }
  }

  const fetchPageData = async () => {
    try {
      setLoading(true)

      const response = await axiosProvider({
        method: 'GET',
        endpoint: `MasterProductList?PageIndex=${
          filterDetails?.pageIndex
        }&PageSize=${filterDetails?.pageSize}&categoryId=${
          filterDetails?.categoryId
        }&brandId=${filterDetails?.brandId}&sellerId=${
          filterDetails?.sellerId
        }&status=${filterDetails?.status}&live=${
          filterDetails?.live
        }&searchText=${encodedSearchText(filterDetails?.searchText)}`
      })
      setLoading(false)
      if (response?.status === 200) {
        setData(response)
      }
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  const handleRowClick = (id) => {
    if (expandedRow === id) {
      setExpandedRow(null)
    } else {
      setExpandedRow(id)
    }
  }

  const getOrderDetail = async (id, sellerProductId) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: 'GET',
        endpoint: `Product/ById?productId=${id}&isDeleted=false&isArchive=false`
      })
      setLoading(false)

      if (response?.data?.code === 200) {
        sellerProductId = sellerProductId
          ? sellerProductId
          : response?.data?.data?.sellerProducts[0]?.id
        setPreviewOffCanvasShow(!previewOffCanvasShow)
        let sellerProduct = response?.data?.data?.sellerProducts?.find(
          (item) => item?.id === sellerProductId
        )

        if (sellerProduct) {
          sellerProduct = {
            ...sellerProduct,
            productPrices: sellerProduct.productPrices.map((item, index) => ({
              ...item,
              checked: index === 0
            }))
          }
        }
        let sellerProducts = response?.data?.data?.sellerProducts

        if (sellerProducts) {
          sellerProducts = sellerProducts?.map((data) => {
            return {
              ...data,
              productPrices: data?.productPrices?.map((item, index) => ({
                ...item,
                checked: index === 0
              }))
            }
          })
        }
        let preview = response?.data?.data

        if (!sellerProduct?.isSizeWisePriceVariant) {
          let productPrice =
            sellerProduct?.productPrices?.length > 0 &&
            sellerProduct?.productPrices[0]
          if (productPrice) {
            let { mrp, sellingPrice, marginPercentage, marginIn, marginCost } =
              productPrice
            fetchCalculation(
              'Product/DisplayCalculation',
              prepareDisplayCalculationData({
                mrp,
                sellingPrice,
                categoryId: preview?.categoryId,
                brandID: sellerProduct?.brandID,
                sellerID: sellerProduct?.sellerID,
                weightSlabId: sellerProduct?.weightSlabId,
                shipmentBy: preview?.shipmentBy,
                shippingPaidBy: preview?.shippingPaidBy,
                marginPercentage,
                marginIn,
                marginCost
              }),
              (displayCalculation) => {
                if (displayCalculation?.customerPricing) {
                  setAllState({
                    ...allState,
                    displayCalculation,
                    preview: { ...preview, sellerProduct, sellerProducts }
                  })
                } else {
                  setAllState({
                    ...allState,
                    preview: { ...preview, sellerProduct, sellerProducts }
                  })
                }
              }
            )
          } else {
            setAllState({
              ...allState,
              preview: { ...preview, sellerProduct, sellerProducts }
            })
          }
        } else {
          setAllState({
            ...allState,
            preview: { ...preview, sellerProduct, sellerProducts }
          })
        }
      }
    } catch {
      setLoading(false)
      showToast(toast, setToast, {
        data: {
          message: _exception?.message,
          code: 204
        }
      })
    }
  }

  useEffect(() => {
    if (id) {
      getOrderDetail(id, sellerProductId)
    }
  }, [id])

  useEffect(() => {
    if (modalShow?.show && modalShow?.type === 'totalSellerSellingProduct') {
      fetchData(`Product/ById?productId=${quickUpdate?.id}`, (res) => {
        setModalShow({
          ...modalShow,
          data: {
            ...res?.data?.data,
            filteredSellerProducts: res?.data?.data?.sellerProducts
          }
        })
      })
    }
  }, [quickUpdate?.isDataUpdated])

  useEffect(() => {
    let apiUrls = [
      {
        endpoint: !isSellerPanel
          ? 'MasterProductList/getProductCounts'
          : 'MasterProductList/getProductCountsWithSellerId',
        queryString: `?sellerId=${isSellerPanel ? userInfo?.userId : ''}`,
        state: 'productCount'
      },
      {
        endpoint: 'SellerData/bindActiveSeller',
        queryString: '?pageindex=0&PageSize=0',
        state: 'sellerDetails'
      },
      {
        endpoint: 'Brand',
        queryString: '?pageIndex=0&pageSize=0',
        state: 'brand'
      },
      {
        endpoint: 'MainCategory/getEndCategory',
        queryString: '',
        state: 'category'
      }
    ]
    const fetchData = async () => {
      let category, sellerDetails, productCount, brand
      const responses = await fetchAllGenericData(apiUrls)
      responses.forEach((response) => {
        switch (response?.state) {
          case 'productCount':
            productCount = response.data
            break

          case 'sellerDetails':
            sellerDetails = response?.data
            break

          case 'brand':
            brand = response?.data
            break

          case 'category':
            category = response?.data
            break

          default:
            break
        }
      })

      setAllState({
        ...allState,
        productCount,
        sellerDetails,
        brand,
        category
      })
    }
    fetchData()
  }, [])

  useEffect(() => {
    if (debounceSearchText) {
      setFilterDetails((draft) => {
        draft.searchText = debounceSearchText
        draft.pageIndex = 1
      })
    } else {
      setFilterDetails((draft) => {
        draft.searchText = ''
        draft.pageIndex = 1
      })
    }
  }, [debounceSearchText])

  useEffect(() => {
    fetchPageData()
  }, [filterDetails])

  return checkPageAccess(pageAccess, allPages?.product, allCrudNames?.read) ? (
    <div className='card'>
      <div className='card-body'>
        <div className='d-flex gap-4 flex-column'>
          {loading && !modalShow?.show && <Loader />}
          {toast?.show && (
            <CustomToast text={toast?.text} variation={toast?.variation} />
          )}
          <div className='row w-100 pv-information-main justify-content-between align-items-center'>
            <div className='col-md-8 pv-info-innercol'>
              <div className='row pv-info-innerbox'>
                <div className='col active-numbers'>
                  <div
                    style={{ borderColor: '#0062D6' }}
                    className='pv-innerbox-col d-flex align-items-center'
                  >
                    <InfoRoundedIcon
                      tooltipText={
                        'Total count excludes archived/deleted products.'
                      }
                    />
                    <h3>
                      {allState?.productCount?.total
                        ? allState?.productCount?.total
                        : 0}
                    </h3>
                    <p style={{ color: '#0062D6' }}>Total</p>
                  </div>
                </div>
                <div className='col active-numbers'>
                  <div
                    style={{ borderColor: '#7831BF' }}
                    className='pv-innerbox-col d-flex align-items-center'
                  >
                    <InfoRoundedIcon
                      tooltipText={"Unique count based on company's SKUs."}
                    />
                    <h3>
                      {allState?.productCount?.unique
                        ? allState?.productCount?.unique
                        : 0}
                    </h3>
                    <p style={{ color: '#7831BF' }}>Unique</p>
                  </div>
                </div>
                <div className='col active-numbers'>
                  <div
                    style={{ borderColor: '#23A423' }}
                    className='pv-innerbox-col d-flex align-items-center'
                  >
                    <InfoRoundedIcon
                      tooltipText={
                        "Active products include live and 'Active' status."
                      }
                    />
                    <h3>
                      {allState?.productCount?.active
                        ? allState?.productCount?.active
                        : 0}
                    </h3>
                    <p style={{ color: '#23A423' }}>Active</p>
                  </div>
                </div>
                <div className='col active-numbers'>
                  <div
                    style={{ borderColor: '#D7B02A' }}
                    className='pv-innerbox-col d-flex align-items-center'
                  >
                    <InfoRoundedIcon
                      tooltipText={
                        'No. of sellers selling same products in system.'
                      }
                    />
                    <h3>
                      {allState?.productCount?.inExisting
                        ? allState?.productCount?.inExisting
                        : 0}
                    </h3>
                    <p style={{ color: '#D7B02A' }}>In Existing</p>
                  </div>
                </div>
                <div className='col active-numbers'>
                  <div
                    style={{ borderColor: '#31BFBF' }}
                    className='pv-innerbox-col d-flex align-items-center'
                  >
                    <InfoRoundedIcon
                      tooltipText={'Inactive products are not active or live.'}
                    />
                    <h3>
                      {allState?.productCount?.inactivate
                        ? allState?.productCount?.inactivate
                        : 0}
                    </h3>
                    <p style={{ color: '#31BFBF' }}>Inactive</p>
                  </div>
                </div>
                <div className='col active-numbers'>
                  <div
                    style={{ borderColor: '#BF3178' }}
                    className='pv-innerbox-col d-flex align-items-center'
                  >
                    <InfoRoundedIcon
                      tooltipText={
                        'In Approval count includes pending products.'
                      }
                    />
                    <h3>
                      {allState?.productCount?.inRequest
                        ? allState?.productCount?.inRequest
                        : 0}
                    </h3>
                    <p style={{ color: '#BF3178' }}>In Approval</p>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-md-3 pv-info-innercol align-items-center p-0'>
              <div className='d-flex flex-wrap gap-3 justify-content-end'>
                {checkPageAccess(
                  pageAccess,
                  allPages?.product,
                  allCrudNames?.write
                ) && (
                  <Dropdown as={ButtonGroup}>
                    <Link to='/manage-product/add-product'>
                      <Button
                        variant='warning'
                        className='fw-600 d-flex align-items-center gap-2'
                      >
                        <i className='m-icon m-icon--plusblack'></i>
                        Add New Product
                      </Button>
                    </Link>
                    {checkPageAccess(
                      pageAccess,
                      [allPages?.addInExisting, allPages?.archiveProduct],
                      allCrudNames?.read
                    ) && (
                      <Dropdown.Toggle
                        split
                        variant='warning'
                        id='dropdown-split-basic'
                      />
                    )}

                    <Dropdown.Menu>
                      {/* {checkPageAccess(
                        pageAccess,
                        allPages?.addInExisting,
                        allCrudNames?.read
                      ) &&
                        !isInventoryModel && (
                          <Dropdown.Item>
                            <Link to='/existing-product'>
                              Add In Existing Product
                            </Link>
                          </Dropdown.Item>
                        )} */}
                      {checkPageAccess(
                        pageAccess,
                        allPages?.archiveProduct,
                        allCrudNames?.read
                      ) && (
                        <Dropdown.Item>
                          <Link to='/manage-product/archive-products'>
                            Archive products
                          </Link>
                        </Dropdown.Item>
                      )}
                      {checkPageAccess(pageAccess, allPages?.product, [
                        allCrudNames?.add,
                        allCrudNames?.update
                      ]) && (
                        <Dropdown.Item
                          onClick={() =>
                            setModalShow({
                              show: !modalShow.show,
                              type: 'bulkUpload'
                            })
                          }
                        >
                          <span>Bulk Upload</span>
                        </Dropdown.Item>
                      )}

                      {checkPageAccess(pageAccess, allPages?.product, [
                        allCrudNames?.add,
                        allCrudNames?.update
                      ]) && (
                        <Dropdown.Item
                          onClick={() =>
                            setModalShow({
                              show: !modalShow.show,
                              type: 'bulkStockUpdate'
                            })
                          }
                        >
                          <span>Bulk Stock Update</span>
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
          </div>

          <div
            style={{ backgroundColor: 'var(--bs-white)' }}
            className='pv-product-table-main rounded'
          >
            <Accordion className='mb-4 pv_accordian'>
              <Accordion.Item eventKey='0'>
                <Accordion.Header className='pv-product-filter-main'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='#000000'
                    width='18px'
                    height='18px'
                    viewBox='0 0 32 32'
                  >
                    <path d='M12,25l6.67,6.67a1,1,0,0,0,.7.29.91.91,0,0,0,.39-.08,1,1,0,0,0,.61-.92V13.08L31.71,1.71A1,1,0,0,0,31.92.62,1,1,0,0,0,31,0H1A1,1,0,0,0,.08.62,1,1,0,0,0,.29,1.71L11.67,13.08V24.33A1,1,0,0,0,12,25ZM3.41,2H28.59l-10,10a1,1,0,0,0-.3.71V28.59l-4.66-4.67V12.67a1,1,0,0,0-.3-.71Z' />
                  </svg>
                  Filter
                </Accordion.Header>
                <Accordion.Body>
                  <div className='row pv-filterprdct-main g-4 align-items-center'>
                    {!isInventoryModel && (
                      <div className='col-md-3'>
                        <Select
                          styles={customStyles}
                          id='sellerDetails'
                          isClearable
                          menuPortalTarget={document.body}
                          value={
                            filterDetails?.sellerId && {
                              label: filterDetails?.sellerName,
                              value: filterDetails?.sellerId
                            }
                          }
                          placeholder='Select Seller'
                          options={
                            allState?.sellerDetails &&
                            allState?.sellerDetails?.map(
                              ({ userId, displayName }) => ({
                                label: displayName,
                                value: userId
                              })
                            )
                          }
                          onChange={(e) => {
                            const fetchAllData = () => {
                              // setLoading(true)
                              Promise.all([
                                callApi(
                                  'AssignBrandToSeller/bySeller&BrandId',
                                  `?sellerId=${e?.value}&pageIndex=0&pageSize=0&status=Active`
                                )
                              ])
                                .then(([brandResp]) => {
                                  // setLoading(false)
                                  setAllState({
                                    ...allState,
                                    sellerBrand: brandResp ?? []
                                  })
                                })
                                .catch(() => {
                                  // setLoading(false)
                                })
                            }
                            if (e?.value) {
                              fetchAllData()
                            } else {
                              setAllState({
                                ...allState,
                                sellerBrand: null
                              })
                            }
                            setFilterDetails((draft) => {
                              draft.sellerId = e?.value ? e?.value : ''
                              draft.sellerName = e?.label ? e?.label : ''
                              draft.brandId = ''
                              draft.brandName = ''
                            })
                          }}
                        />
                      </div>
                    )}
                    <div className={`col-md-${isInventoryModel ? '4' : '3'}`}>
                      <Select
                        styles={customStyles}
                        id='brandId'
                        isClearable
                        menuPortalTarget={document.body}
                        value={
                          filterDetails?.brandId && {
                            label: filterDetails?.brandName,
                            value: filterDetails?.brandId
                          }
                        }
                        placeholder='Select Brand'
                        options={
                          allState?.sellerBrand
                            ? allState?.sellerBrand?.map(
                                ({ brandId, brandName }) => ({
                                  label: brandName,
                                  value: brandId
                                })
                              )
                            : allState?.brand?.map(({ id, name }) => ({
                                value: id,
                                label: name
                              }))
                        }
                        onChange={(e) => {
                          setFilterDetails((draft) => {
                            draft.brandId = e?.value ? e?.value : ''
                            draft.brandName = e?.label ? e?.label : ''
                          })
                        }}
                      />
                    </div>
                    <div className={`col-md-${isInventoryModel ? '4' : '3'}`}>
                      <Select
                        styles={customStyles}
                        id='status'
                        menuPortalTarget={document.body}
                        isClearable
                        value={
                          filterDetails?.status && {
                            label: filterDetails?.status,
                            value: filterDetails?.status
                          }
                        }
                        placeholder='Product Status'
                        options={productStatus}
                        onChange={(e) => {
                          setFilterDetails((draft) => {
                            draft.status = e?.value ? e?.value : ''
                          })
                        }}
                      />
                    </div>
                    <div className={`col-md-${isInventoryModel ? '4' : '3'}`}>
                      <Select
                        styles={customStyles}
                        id='live'
                        isClearable
                        menuPortalTarget={document.body}
                        placeholder='Live Status'
                        value={
                          filterDetails?.live && {
                            label:
                              filterDetails?.live?.toLowerCase() === 'true'
                                ? 'Yes'
                                : 'No',
                            value: filterDetails?.live
                          }
                        }
                        options={[
                          {
                            label: 'Yes',
                            value: 'true'
                          },
                          {
                            label: 'No',
                            value: 'false'
                          }
                        ]}
                        onChange={(e) => {
                          setFilterDetails((draft) => {
                            draft.live = e?.value ? e?.value : ''
                          })
                        }}
                      />
                    </div>
                    <div className='col-md-6'>
                      <Select
                        styles={customStyles}
                        id='categoryId'
                        menuPortalTarget={document.body}
                        placeholder='Select Category'
                        isClearable
                        value={
                          filterDetails?.categoryId && {
                            label: filterDetails?.categoryName,
                            value: filterDetails?.categoryId
                          }
                        }
                        options={
                          allState?.category &&
                          allState?.category?.map(
                            ({ id, pathNames, name }) => ({
                              value: id,
                              label: pathNames,
                              categoryName: name
                            })
                          )
                        }
                        onChange={(e) => {
                          setFilterDetails((draft) => {
                            draft.categoryId = e?.value ? e?.value : ''
                            draft.categoryName = e?.label ? e?.label : ''
                          })
                        }}
                      />
                    </div>
                    <div className='col-md-3'>
                      <SearchBox
                        placeholderText='Search'
                        searchclassnamewrapper={'searchbox-wrapper w-100'}
                        btnVariant={'secondary'}
                        isClearable
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e?.target?.value ?? '')
                        }}
                      />
                    </div>

                    <div className='col-md-3 gap-2 d-flex align-items-center'>
                      <Button
                        variant='light'
                        size='md'
                        onClick={() => {
                          setSearchText('')
                          setFilterDetails((draft) => {
                            draft.sellerId = isInventoryModel
                              ? filterDetails?.sellerId
                              : ''
                            draft.brandId = ''
                            draft.categoryId = ''
                            draft.live = ''
                            draft.status = ''
                            draft.searchText = ''
                            draft.pageIndex = 1
                          })
                        }}
                      >
                        Reset
                      </Button>
                    </div>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <div className='d-flex align-items-center gap-3 justify-content-end'>
              <div className='d-flex align-items-center'>
                <label className='me-1'>Show</label>
                <select
                  styles={customStyles}
                  menuPortalTarget={document.body}
                  name='dataget'
                  value={filterDetails?.pageSize}
                  id='parpageentries'
                  className='form-select me-1'
                  onChange={(e) => {
                    setFilterDetails((draft) => {
                      draft.pageSize = e?.target?.value
                      draft.pageIndex = 1
                    })
                  }}
                >
                  <option value='10'>10</option>
                  <option value='25'>25</option>
                  <option value='50'>50</option>
                  <option value='100'>100</option>
                  <option value='200'>200</option>
                  <option value='500'>500</option>
                </select>
              </div>

              <div className='page-range'>
                {calculatePageRange({
                  ...filterDetails,
                  recordCount: data?.data?.pagination?.recordCount ?? 0
                })}
              </div>
            </div>
            <Table className='align-middle mt-3 table-list manage-product-table'>
              <thead className='align-middle'>
                <tr>
                  <th>Product Details</th>
                  <th>Brand</th>
                  <th>Pricing Details</th>
                  <th>Quantity</th>
                  <th>Status</th>
                  <th>Live</th>
                  <th className='text-center'>Action</th>
                </tr>
              </thead>
              <tbody className='border border-1' style={{ boxShadow: 'unset' }}>
                {data?.data?.data?.length > 0 ? (
                  data?.data?.data?.map((data) => (
                    <React.Fragment
                      key={`${data.id}${Math.floor(Math.random() * 10000000)}`}
                    >
                      <tr
                        className='timeline'
                        key={`${data.id}${Math.floor(
                          Math.random() * 10000000
                        )}`}
                      >
                        <td onClick={() => handleRowClick(data?.id)}>
                          <div className='d-flex gap-3 align-items-center'>
                            <img
                              className='img-thumbnail table-img-box'
                              src={
                                data?.image1 &&
                                `${process.env.REACT_APP_IMG_URL}${_productImg_}${data?.image1}`
                              }
                              alt='...'
                            />
                            <div>
                              <p className='pv-font-hard mb-1'>
                                {' '}
                                {data?.productName}
                              </p>
                              <small>Product Master Code: {data?.id}</small>
                              <Button
                                onClick={() => handleRowClick(data?.id)}
                                variant='outline-primary'
                                className='btn-outline-lightblue  btn-sm d-flex align-items-center gap-1'
                                style={{ lineHeight: '10px' }}
                              >
                                Product Variants:{' '}
                                <span>{data?.totalVariant}</span>
                                <svg
                                  style={
                                    expandedRow === data?.id
                                      ? { transform: 'rotate(180deg)' }
                                      : { transform: 'rotate(0deg)' }
                                  }
                                  height='15'
                                  width='15'
                                  viewBox='0 0 20 20'
                                  aria-hidden='true'
                                  focusable='false'
                                  className='css-tj5bde-Svg'
                                >
                                  <path d='M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z'></path>
                                </svg>
                              </Button>
                            </div>
                          </div>
                        </td>
                        <td>
                          {data?.brandName
                            ? data?.brandName
                            : data?.childList?.length > 0
                            ? data?.childList[0]?.brandName
                            : ''}
                        </td>
                        <td className='text-center'>-</td>
                        <td>{data?.quantity}</td>
                        <td>
                          <HKBadge
                            badgesbgname={
                              data?.childList.some(
                                (child) =>
                                  child?.status?.toLowerCase() === 'active'
                              )
                                ? 'success'
                                : 'danger'
                            }
                            badgesTxtname={
                              data?.childList.some(
                                (child) =>
                                  child?.status?.toLowerCase() === 'active'
                              )
                                ? 'Active'
                                : 'Inactive'
                            }
                            badgeClassname={''}
                          />
                        </td>
                        <td>
                          {data?.childList.some((child) => child.live)
                            ? 'Yes'
                            : 'No'}
                        </td>
                        <td className='text-center'> - </td>
                      </tr>
                      {expandedRow === data?.id &&
                        data?.childList?.map((expandedData) => (
                          <tr
                            className='position-relative pv-productd-remhover'
                            key={Math.floor(Math.random() * 10000000)}
                          >
                            <td
                              style={{ paddingLeft: '40px' }}
                              className='border-1 border-start border-top border-bottom d-block'
                            >
                              <div className='d-flex gap-3 align-items-center'>
                                <img
                                  className='img-thumbnail table-img-box'
                                  src={
                                    expandedData?.image1 &&
                                    `${process.env.REACT_APP_IMG_URL}${_productImg_}${expandedData?.image1}`
                                  }
                                  alt='...'
                                />
                                <div
                                  className='text-start'
                                  style={{ cursor: 'pointer' }}
                                >
                                  <div>
                                    <p
                                      className='pv-font-hard mb-1'
                                      onClick={() => {
                                        getOrderDetail(
                                          expandedData?.id,
                                          expandedData?.sellerProductId
                                        )
                                      }}
                                    >
                                      {' '}
                                      {expandedData?.productName}
                                    </p>
                                    <small className='pv-font-hard'>
                                      Product Code: {expandedData?.id}
                                    </small>
                                    {expandedData?.status === 'Active' && (
                                      <div>
                                        <small className='pv-font-hard'>
                                          {' '}
                                          URL :
                                        </small>{' '}
                                        <small>
                                          <Link
                                            to={`${getFrontendUrl()}${spaceToDash(
                                              expandedData?.productName
                                            )}/${encodeId(expandedData?.guid)}`}
                                            target='_blank'
                                          >
                                            Customer Page Preview
                                          </Link>
                                        </small>
                                      </div>
                                    )}
                                    <div>
                                      <small className='pv-font-hard'>
                                        {' '}
                                        SKU Code :
                                      </small>{' '}
                                      <span>
                                        {expandedData?.companySKUCode}
                                      </span>
                                    </div>
                                    {expandedData?.colorVariant && (
                                      <div>
                                        <small className='pv-font-hard'>
                                          Color Variant :
                                        </small>{' '}
                                        <span>
                                          {expandedData?.colorVariant}
                                        </span>
                                      </div>
                                    )}

                                    {expandedData?.sizeVariant && (
                                      <div>
                                        <small className='pv-font-hard'>
                                          Size Variant :
                                        </small>{' '}
                                        <span>{expandedData?.sizeVariant}</span>
                                      </div>
                                    )}

                                    {expandedData?.specificationVariant && (
                                      <div>
                                        <small className='pv-font-hard'>
                                          Specification Variant :
                                        </small>{' '}
                                        <span>
                                          {expandedData?.specificationVariant}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                  {!isInventoryModel && (
                                    <Button
                                      variant='primary'
                                      className='btn-ct-lightblue mt-2 btn-sm'
                                      style={{ lineHeight: '12px' }}
                                      onClick={() => {
                                        fetchData(
                                          `Product/ById?productId=${expandedData?.id}`,
                                          (res) => {
                                            setModalShow({
                                              show: !modalShow.show,
                                              type: 'totalSellerSellingProduct',
                                              data: {
                                                ...res?.data?.data,
                                                filteredSellerProducts:
                                                  res?.data?.data
                                                    ?.sellerProducts
                                              }
                                            })
                                          }
                                        )
                                      }}
                                    >
                                      Total Sellers:{' '}
                                      <span>
                                        {expandedData?.totalSellerCount}
                                      </span>
                                    </Button>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td className='border-top border-bottom'>
                              {expandedData?.brandName}
                            </td>
                            <td className='border-top border-bottom'>
                              <div className='d-flex flex-column gap-1 align-items-start'>
                                <div className='badge text-bg-light'>
                                  <span className='pv-font-hard'>
                                    Selling Price :{' '}
                                  </span>
                                  <span>
                                    {currencyIcon} {expandedData?.sellingPrice}
                                  </span>
                                </div>
                                <div className='badge text-bg-light'>
                                  <span className='pv-font-hard'>MRP : </span>
                                  <span>
                                    {currencyIcon} {expandedData?.mrp}
                                  </span>
                                </div>
                                <div className='badge text-bg-light'>
                                  <span className='pv-font-hard'>
                                    Discount :{' '}
                                  </span>
                                  <span>{expandedData?.discount}%</span>
                                </div>
                              </div>
                            </td>
                            <td className='border-top border-bottom'>
                              {expandedData?.quantity}
                            </td>
                            <td className='border-top border-bottom'>
                              <HKBadge
                                badgesbgname={
                                  expandedData?.status?.toLowerCase() ===
                                  'active'
                                    ? 'success'
                                    : 'danger'
                                }
                                badgesTxtname={expandedData?.status}
                                badgeClassname={''}
                              />
                            </td>
                            <td className='border-top border-bottom text-center'>
                              {expandedData?.live ? 'Yes' : 'No'}
                            </td>
                            <td className='text-center border-top border-bottom border-end'>
                              <DropdownButton
                                align='end'
                                title={<i className='m-icon m-icon--dots'></i>}
                                id='dropdown-menu-align-end'
                                className='custom_dropdown'
                              >
                                {checkPageAccess(
                                  pageAccess,
                                  allPages?.product,
                                  allCrudNames?.update
                                ) &&
                                  !expandedData?.isExistingProduct && (
                                    <Link
                                      className='dropdown-item'
                                      to={`/manage-product/add-product?id=${encodeId(
                                        expandedData?.id
                                      )}&sellerId=${encodeId(
                                        expandedData?.sellerId
                                      )}`}
                                    >
                                      <EditIcon />
                                      Edit
                                    </Link>
                                  )}
                                {/* {checkPageAccess(
                                  pageAccess,
                                  allPages?.addInExisting,
                                  allCrudNames?.update
                                ) &&
                                  !isInventoryModel && (
                                    <Link
                                      className='dropdown-item'
                                      to={`/existing-product-form/${encodeId(
                                        expandedData?.id
                                      )}`}
                                    >
                                      <AddInExistingIcon />
                                      Add in existing
                                    </Link>
                                  )} */}
                                <Dropdown.Item
                                  eventKey='2'
                                  onClick={() =>
                                    getOrderDetail(
                                      expandedData?.id,
                                      expandedData?.sellerProductId
                                    )
                                  }
                                >
                                  <Previewicon />
                                  Preview
                                </Dropdown.Item>
                                {checkPageAccess(
                                  pageAccess,
                                  allPages?.product,
                                  allCrudNames?.update
                                ) && (
                                  <Dropdown.Item
                                    eventKey='2'
                                    onClick={() => {
                                      setQuickUpdate({
                                        sellerId: expandedData?.sellerId,
                                        id: expandedData.id,
                                        show: !quickUpdate.show
                                      })
                                    }}
                                  >
                                    <QuickEditIcon />
                                    Quick Edit
                                  </Dropdown.Item>
                                )}
                                {checkPageAccess(
                                  pageAccess,
                                  allPages?.archiveProduct,
                                  allCrudNames?.delete
                                ) && (
                                  <Dropdown.Item
                                    eventKey='2'
                                    onClick={() => {
                                      Swal.fire({
                                        title: 'Are you sure?',
                                        text: 'You are about to archive this product. This action cannot be undone.',
                                        icon: _SwalDelete.icon,
                                        showCancelButton: true,
                                        confirmButtonText: 'Yes, archive it!',
                                        cancelButtonText:
                                          _SwalDelete.cancelButtonText,
                                        confirmButtonColor:
                                          _SwalDelete.confirmButtonColor,
                                        cancelButtonColor:
                                          _SwalDelete.cancelButtonColor
                                      }).then((result) => {
                                        if (result.isConfirmed) {
                                          handleArchive({
                                            productId: expandedData?.id,
                                            sellerProductId:
                                              expandedData?.sellerProductId
                                          })
                                        } else if (result.isDenied) {
                                        }
                                      })
                                    }}
                                  >
                                    <ArchieveIcon />
                                    Archive
                                  </Dropdown.Item>
                                )}
                              </DropdownButton>
                            </td>
                          </tr>
                        ))}
                    </React.Fragment>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7} className='text-center'>
                      {data?.data?.message}
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {data?.data?.pagination?.pageCount > 0 && (
              <ReactPaginate
                className='list-inline m-cst--pagination d-flex justify-content-end gap-1'
                breakLabel='...'
                nextLabel=''
                onPageChange={handlePageClick}
                pageRangeDisplayed={pageRangeDisplayed}
                pageCount={data?.data?.pagination?.pageCount}
                previousLabel=''
                renderOnZeroPageCount={null}
                forcePage={filterDetails?.pageIndex - 1}
              />
            )}
          </div>
        </div>
      </div>

      <Suspense fallback={<Loader />}>
        {modalShow?.show && modalShow?.type === 'bulkUpload' && (
          <BulkUpload
            modalShow={modalShow}
            setModalShow={setModalShow}
            setLoading={setLoading}
            allState={allState}
            setToast={setToast}
            toast={toast}
            fetchPageData={fetchPageData}
            setAllState={setAllState}
          />
        )}

        {modalShow?.show && modalShow?.type === 'bulkStockUpdate' && (
          <BulkStockUpdate
            modalShow={modalShow}
            setModalShow={setModalShow}
            setLoading={setLoading}
            allState={allState}
            setToast={setToast}
            toast={toast}
            fetchPageData={fetchPageData}
            setAllState={setAllState}
          />
        )}

        {modalShow?.show && modalShow?.type === 'totalSellerSellingProduct' && (
          <TotalSellerSellingProduct
            loading={loading}
            modalShow={modalShow}
            setModalShow={setModalShow}
            quickUpdate={quickUpdate}
            setQuickUpdate={setQuickUpdate}
            toast={toast}
            handleArchive={handleArchive}
            pageAccess={pageAccess}
          />
        )}

        {quickUpdate?.show && (
          <QuickUpdate
            quickUpdate={quickUpdate}
            setQuickUpdate={setQuickUpdate}
            setToast={setToast}
            toast={toast}
            fetchData={fetchPageData}
          />
        )}

        {allState?.preview && (
          <ProductDetail
            data={data}
            allState={allState}
            setAllState={setAllState}
            previewOffCanvasShow={previewOffCanvasShow}
            setPreviewOffCanvasShow={setPreviewOffCanvasShow}
          />
        )}
      </Suspense>
    </div>
  ) : (
    <NotFound />
  )
}

export default ManageProduct
